import { TripPlannerPax } from '@apps/main/modules/recipe/pax';

import type {
  ExposedRecipe,
  OldExposedRecipe,
  ExposedIngredient,
  OldExposedIngredient,
} from '@libs/trip-planner-interfaces';
import { IngredientType } from '@libs/trip-planner-interfaces';

import { isOldExposedFlightIngredient } from './recipeSerializer.flight.helpers';
import { isOldExposedHotelIngredient } from './recipeSerializer.hotel.helpers';

export function encodeRecipe(recipeJSON: ExposedRecipe): string {
  return window.btoa(encodeURIComponent(JSON.stringify(recipeJSON)));
}

export function decodeRecipe(
  encodedRecipe: string
): ExposedRecipe | OldExposedRecipe {
  // NOTE:
  // Default parseQuery function from vue-router replaces '+' sign with space (check source code).
  // This breaks query parameters which are base64 encoded.
  // Space is not base64 valid character, hence replacing it back fixes the problem without breaking encoding.
  encodedRecipe = encodedRecipe.replace(/ /g, '+');

  let recipeJSON: ExposedRecipe | OldExposedRecipe;
  try {
    recipeJSON = JSON.parse(
      decodeURIComponent(encodeURIComponent(window.atob(encodedRecipe)))
    );
    if (typeof recipeJSON === 'string') {
      recipeJSON = JSON.parse(recipeJSON);
    }
    return recipeJSON;
  } catch {
    try {
      recipeJSON = JSON.parse(decodeURIComponent(window.atob(encodedRecipe)));
      if (typeof recipeJSON === 'string') {
        recipeJSON = JSON.parse(recipeJSON);
      }
      return recipeJSON;
    } catch (error) {
      throw new Error(`Invalid encoded recipe. ${error}`);
    }
  }
}

export function isOldExposedRecipe(
  exposedRecipe: ExposedRecipe | OldExposedRecipe
): exposedRecipe is OldExposedRecipe {
  const areOldIngredients = exposedRecipe.ingredients.some(
    (ingredient: ExposedIngredient | OldExposedIngredient) => {
      if (ingredient.ingredientType === IngredientType.Hotel) {
        return isOldExposedHotelIngredient(ingredient);
      } else if (ingredient.ingredientType === IngredientType.Flight) {
        return isOldExposedFlightIngredient(ingredient);
      }
      return false;
    }
  );
  const isOldPax = TripPlannerPax.isOldPax(exposedRecipe.pax);

  return areOldIngredients || isOldPax || 'suggestionSortType' in exposedRecipe;
}
